/*
FAQ under the releases calendar as accordions. The Ghost page body (written daily by
server/releases-page) keeps each question as an <h3> with its answer in the paragraphs after
it, so search engines and readers without JavaScript get the whole text; here every question
becomes a native <details> with its answer inside, closed until clicked. Runs once per page
(PJAX re-runs are no-ops). Needs page-releases.hbs.
*/
import { element } from './eventsData';

const FAQ_HEADING = '#frequently-asked-questions';

export default function releasesFaq() {
    const heading = document.querySelector(`.th-rel__text ${FAQ_HEADING}`);
    if (!heading || heading.dataset.faq === 'ready') {
        return;
    }
    heading.dataset.faq = 'ready';
    const list = element('div', 'th-faq');
    let item = null;
    let node = heading.nextElementSibling;
    while (node && node.tagName !== 'H2') {
        const next = node.nextElementSibling;
        if (node.tagName === 'H3') {
            item = element('details', 'th-faq__item');
            const question = element('summary', 'th-faq__question', node.textContent);
            question.id = node.id;
            item.append(question);
            list.append(item);
            node.remove();
        } else if (item) {
            item.append(node);
        }
        node = next;
    }
    heading.after(list);
}
